import Pagination from "../../../components/pagination/Pagination";
import connect from "react-redux/es/connect/connect";
import { getUsers } from "../../../redux/actions/userActions";
const mapStateToProps = (state, ownProps) => {
	return {
		page: state.user.page,
		pages: state.user.pages,
		pageSize: state.user.pageSize,
		nbItems: state.user.users.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		getNext: page => {
			const nextPage = page;
			dispatch(getUsers({ page: nextPage }));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Pagination);



// WEBPACK FOOTER //
// src/containers/admin/users/PaginationContainer.js